import { render, staticRenderFns } from "./PayrollMovementGroupDetail.vue?vue&type=template&id=19efc0cb&scoped=true"
import script from "./PayrollMovementGroupDetail.vue?vue&type=script&lang=js"
export * from "./PayrollMovementGroupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19efc0cb",
  null
  
)

export default component.exports